import React, { useEffect } from 'react';

import { TopBar } from './components/TopBar';
import { Main } from './components/Main';
import { ErrorBoundary } from 'hooks/ErrorBoundary/ErrorBoundary';
import { Card } from './components/Card';
import { Table } from './components/Table';
import { TableHead } from './components/Table/TableHead';
import { TableBody } from './components/Table/TableBody';
import Backdrop from 'components/util/loader/.mixins';

import type { IRouterProps } from 'pages/orderHistory';
import { useOrderDetails } from './hooks/useOrderDetails';
import { useSnackbar } from 'hooks/useSnackbar';
import { usePagination } from 'hooks/usePagination';
import { IOrderHistoryVariables, useOrderHistory } from './hooks/useOrderHistory';

interface IOrderHistoryDetailsProps extends IRouterProps {
  params: IOrderHistoryVariables;
}

export const OrderHistoryDetails = ({ router, params: orderDetailsRouteParams }: IOrderHistoryDetailsProps) => {
  const { Snackbar, toggleSnackbar } = useSnackbar({ severity: 'error', autoHideDuration: 8000 });

  const { Pagination, initialRow, nextRows, setTotalRows } = usePagination();

  const { loadingOrderDetails, orderDetails, errorOrderDetails } = useOrderDetails({
    variables: orderDetailsRouteParams
  });

  const { loadingOrderHistory, orderHistory, errorOrderHistory } = useOrderHistory({
    variables: { ...orderDetailsRouteParams, initialRow, nextRows }
  });

  const loading = loadingOrderDetails || loadingOrderHistory;

  useEffect(() => {
    if (orderHistory && orderHistory.length > 0) {
      setTotalRows(orderHistory[0].totalRows);
    }
    if (orderHistory && orderHistory.length === 0) {
      setTotalRows(0);
    }
  }, [orderHistory]);

  useEffect(() => {
    if (errorOrderDetails || errorOrderHistory) {
      toggleSnackbar();
    }
  }, [errorOrderDetails, errorOrderHistory]);

  return (
    <>
      <TopBar productName={orderDetails?.productName} router={router} />

      <ErrorBoundary message="Ocorreu um problema ao carregar os detalhes do pedido. Por favor, tente novamente.">
        <Main errorOrderDetails={errorOrderDetails} errorOrderHistory={errorOrderHistory}>
          <Card orderDetails={orderDetails!} />

          <Table>
            <TableHead />
            {orderHistory && <TableBody order={orderHistory} />}
          </Table>
        </Main>
      </ErrorBoundary>

      <Pagination />

      <Snackbar>Ocorreu um problema ao carregar os detalhes do pedido. Por favor, tente novamente.</Snackbar>

      {loading && <Backdrop state={{ loading }} />}
    </>
  );
};
